module.exports = __webpack_public_path__ + "img/tel-sp.7a455524.png";